<template>
    <div id="ptDrawer">
      <a-drawer
        :placement="placement"
        :destroyOnClose="true"
        :mask="true"
        :maskClosable="true"
        :wrapClassName="drawerInfo.visible?'openClass':''"
        @close="drawerInfoClose"
        :closable="closable"
        :visible="drawerInfo.visible"
        :width=width
        :z-index="zIndex"
        :class='topClass'
        :wrapStyle="$slots.footer?{height: 'calc(100% - 178px)',overflow: 'auto',paddingBottom: '178px'}:{}"
      >
       <div slot="title" class="header">
         <div @click="drawerInfoClose" class="close">
          <pt-icon class="" type="icon-guanbi-copy" :title="$t('baseVO.close')"></pt-icon>
         </div>
         <div class="title_text">
           {{title}}
         </div>
          <div></div>
       </div>
        <div  :style="{height: $slots.footer?'calc(100vh - 167px)':'calc(100vh - 125px)'}" v-bar>
          <div>
            <slot name="content" class="show_drawerInfo"></slot>
          </div>
        </div>

        <div  v-if="$slots.footer" class="foolter">
          <slot name="footer" >
          </slot>
        </div>

      </a-drawer>
    </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'ptDrawer',
    props:{
      title:{
        type:String,
        default:'',
      },
      zIndex:{
        default:1000,
        type:Number
      },
      visible:{
        type:Boolean,
        default: false,
      },
      closable:{
        type:Boolean,
        default: false,
      },
      topClass:{
        type:String,
        default:null
      },
      placement:{
        type:String,
        default:'right'
      },
      width:{
        type:Number,
        default:700,
      },
    },
    data(){
      return {
        drawerInfo:{
          visible: false,
        }
      }
    },
    watch:{
      visible(newValue){
        this.drawerInfo.visible = newValue;
        // if(newValue){
        //   document.getElementsByTagName('body')[0].classList.add("drawerScollHide")
        // }else{
        //   document.getElementsByTagName('body')[0].classList.remove("drawerScollHide")
        // }
        if(newValue){
          var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
          if(!isMac){
            document.getElementsByTagName('body')[0].classList.add("drawerScollHide")
          }
        }else{
          document.getElementsByTagName('body')[0].classList.remove("drawerScollHide")
        }
      }
    },
    mounted(){
      Vue.prototype.$drawer = this
    },
    methods:{
      drawerInfoClose(){
        this.$emit("close");
        this.$store.dispatch('ToggleTableHighlight', false)
      },
      onCancel(){
        console.log("drawerInfo close")
        this.$emit('onCancel')
      },
      onConfrim(){
        this.$emit('onConfrim')
      },
    }
  }
</script>

<style scoped lang="less">
  @keyframes rotate{
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(180deg);
    }
  }
  .header{
    display: flex;
    justify-content: space-between;
    .title_text{
      font-size: 18px;
      color:#333;
    }
    .close{
      cursor: pointer;
    }
    .close:hover{
      animation:rotate 0.5s;
      animation-delay:0.5s;
      animation-iteration-count:1;
    }
  }
  .foolter{
    display: flex;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 10px 16px;
    background: #fff;
    justify-content: flex-end;
  }
</style>
<style lang="less">
  .ant-drawer-body{
    padding: 0;
    position: relative;
  }
  .ant-drawer{
    z-index: 999;
  }
  .ant-drawer-wrapper-body{
    overflow: hidden !important;
  }
  .openClass{
    transform: translateX(0px) !important;
  }
</style>